import { render, staticRenderFns } from "./baseLayout.vue?vue&type=template&id=36187630&scoped=true"
import script from "./baseLayout.vue?vue&type=script&lang=js"
export * from "./baseLayout.vue?vue&type=script&lang=js"
import style0 from "./baseLayout.vue?vue&type=style&index=0&id=36187630&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36187630",
  null
  
)

export default component.exports